import React, { useContext, useState } from "react";
import styled from "styled-components";
import ProductCard from "../Card/ProductCard";
import { useOutletContext } from "react-router-dom";
import { CartContext } from "../../../contexts/MiniStore/CartContext";
import { enqueueSnackbar } from "notistack";

const MsTrendingNow = () => {
  const { isGrid, handleOpenProductModal, currentPage } = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const {
    cart,
    addToCart,
    updateQuantity,
    handleRatingChange,
    products,
    setProducts,
    setPageCount,
  } = useContext(CartContext);

  const handleAddToCart = async (product) => {
    if (product?.availableQty < 1) {
      enqueueSnackbar("Product quantity not available", { variant: "warning" });
      return;
    }
    // console.log(
    //   "onAddToCart id and hasVariant",
    //   product.id,
    //   product?.hasVariant
    // );
    if (product?.hasVariant) {
      handleOpenProductModal(product);
    } else {
      addToCart({
        productId: product.id,
      });
    }
  };

  return (
    <div>
      <CardsWrapper isGrid={isGrid}>
        {Array.isArray(products) && products.length > 0 ? (
          products.map((product) => {
            const cartItem = cart.find(
              (item) => item.id === product.variant_ids?.[0]
            );
            return (
              <ProductCard
                key={product.id}
                id={product.id}
                title={product.title}
                rating={product.rating}
                quantity={cartItem ? cartItem.quantity : 0}
                currency={product.currency}
                price={product.price}
                img={product.image_1920}
                onClick={() => handleOpenProductModal(product)}
                // onRatingChange={handleRatingChange}
                onQuantityChange={(id, change) =>
                  updateQuantity({
                    productId: product.variant_ids?.[0],
                    qtyChange: change,
                  })
                }
                onAddToCart={() => handleAddToCart(product)}
                viewType={isGrid ? "grid" : "list"}
                hasVariant={product.hasVariant}
              />
            );
          })
        ) : isLoading ? (
          <p className="text-center">Loading....</p>
        ) : (
          <p className="text-center">No Data</p>
        )}
      </CardsWrapper>
    </div>
  );
};

export default MsTrendingNow;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ isGrid }) =>
    isGrid ? "repeat(auto-fit, minmax(250px, 1fr))" : "1fr"};
  gap: 16px;
  width: 100%;
  max-width: 900px;
  place-items: start center;
`;
